var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"done-icon",attrs:{"height":"100%","viewBox":"0 0 26 26","fill":"none"}},[_c('circle',{attrs:{"cx":"13","cy":"13","r":"13","fill":"#008656"}}),_c('path',{attrs:{"d":"M6.93359 12.8127L10.8542 16.7333L19.0876 8.5","stroke":"white","stroke-width":"2"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }